import { render, staticRenderFns } from "./purchasePriceVerification.vue?vue&type=template&id=4d941494&scoped=true"
import script from "./purchasePriceVerification.vue?vue&type=script&lang=js"
export * from "./purchasePriceVerification.vue?vue&type=script&lang=js"
import style0 from "./purchasePriceVerification.vue?vue&type=style&index=0&id=4d941494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d941494",
  null
  
)

export default component.exports